import Vue from "vue"
import vuetify from "@/plugins/vuetify"

/** Theme modes; "system" follows prefers-color-scheme */
export const themeModes = ["system", "light", "dark"]

export const THEME_STORAGE_KEY = "theme"

const media =
  typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia("(prefers-color-scheme: dark)")
    : null

const readMode = () => {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY)
    if (themeModes.includes(saved)) return saved
  } catch (e) {}
  return "system"
}

/** Reactive theme state, shared by the switcher; dark = the theme actually applied */
export const themeState = Vue.observable({ mode: readMode(), dark: false })

const applyTheme = () => {
  const dark =
    themeState.mode === "dark" ||
    (themeState.mode === "system" && !!media?.matches)
  themeState.dark = dark
  document.documentElement.classList.toggle("theme-dark", dark)
  vuetify.framework.theme.dark = dark
}

/** Switches the theme mode and remembers the choice */
export const setThemeMode = (mode) => {
  themeState.mode = mode
  try {
    localStorage.setItem(THEME_STORAGE_KEY, mode)
  } catch (e) {}
  applyTheme()
}

media?.addEventListener?.("change", applyTheme)
applyTheme()
